import React from "react";
import { Box, Chip, Typography } from "@mui/material";
import { RichTextDisplay } from "@/components/common";

/**
 * QuestionFeedback — inline feedback shown below a question after auto-submit
 * during an active Trial Lab session.
 */
const QuestionFeedback = ({ feedback }) => {
  const { isCorrect, correctAnswer, explanation } = feedback;

  return (
    <Box
      sx={{
        mt: 1,
        mb: 2,
        p: 2,
        borderRadius: 2,
        border: "1px solid",
        borderColor: isCorrect ? "success.light" : "error.light",
        bgcolor: isCorrect ? "#e8f5e9" : "#ffebee",
      }}
    >
      <Box display="flex" alignItems="center" gap={1} mb={explanation ? 1 : 0}>
        <Chip
          size="small"
          label={isCorrect ? "Correct!" : "Incorrect"}
          color={isCorrect ? "success" : "error"}
        />
        {!isCorrect && correctAnswer != null && (
          <Typography variant="body2" color="text.secondary">
            Correct answer:{" "}
            <Box component="span" fontWeight={700} color="success.dark">
              {Array.isArray(correctAnswer)
                ? correctAnswer.flat().join(" / ")
                : String(correctAnswer)}
            </Box>
          </Typography>
        )}
      </Box>

      {explanation && (
        <RichTextDisplay
          content={explanation}
          sx={{ fontSize: "0.9rem", color: "text.secondary", mt: 0.5 }}
        />
      )}
    </Box>
  );
};

export default QuestionFeedback;
